// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Jq","link":"e_Kq","imageContainer":"e_Lq","author":"e_Mq","text":"e_Nq","buttonIcon":"e_Oq"};